export default "__VITE_ASSET__4e72c497__"